export default __webpack_public_path__ + "static/media/large_rectangle.f2e1a1b7.png";